import { useEffect, useState } from "react";

const clamp = (value, min, max) => Math.max(min, Math.min(max, value));

const StepWiseForm = ({ children = [] }) => {
    const [currentPageIndex, setCurrentPageIndex] = useState(0);

    function nextPage() {
        setCurrentPageIndex((i) => {
            let index = clamp(i + 1, 0, children.length - 1);
            document.getElementById("dashboard-main")?.scrollTo(0,0);
            return index;
        });
    }

    function prevPage() {
        setCurrentPageIndex((i) => {
            let index = clamp(i - 1, 0, children.length - 1);
            document.getElementById("dashboard-main")?.scrollTo(0,0);
            return index;
        });
    }

    return (
        <div className="step-wise">
            <div className="view">{children[currentPageIndex]}</div>
            <div className="d-flex controls justify-content-center mt-3">
                {currentPageIndex > 0 && (
                    <button type="button" className="btn btn-light text-black-50 m-2" onClick={prevPage}>
                        Previous
                    </button>
                )}

                {currentPageIndex !== children.length - 1 && (
                    <button type="button" className="btn btn-primary text-light m-2" onClick={nextPage}>
                        Next
                    </button>
                )}
            </div>
        </div>
    );
};

export default StepWiseForm;
